<template>
  <file-list
    :model-value="documentAgreementSource.extraFiles || []"
    :disabled="readonly"
    :name-folder="String(documentAgreementSource.number)"
    label="Додаткові документи"
    @update:model-value="onUpdate"></file-list>
</template>

<script lang="ts">
import FileList from '@/components/FileList.vue'
import { useDocumentAgreement } from '../documentAgreement'
import { File } from '@/utils/types/helpers'

export default {
  name: 'ExtraDocuments',
  components: { FileList },
  setup() {
    const { documentAgreementSource, readonly, updateExtraFiles } =
      useDocumentAgreement()

    const onUpdate = (files: File[]) => {
      documentAgreementSource.extraFiles = files
      return updateExtraFiles()
    }

    return { documentAgreementSource, readonly, onUpdate }
  },
}
</script>
